<!--
growerDescription
name
address
catchment
-->
<rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
  <div class="inputs">
    <div class="field" *ngIf="otherProperty.id">
      <div class="label">System Id</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>System Id</mat-label>
          <input matInput [(ngModel)]="otherProperty.id" readonly disabled />
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <div class="label">Company / Organisation</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Company / Organisation</mat-label>
          <input matInput [(ngModel)]="otherProperty.growerDescription" placeholder="QLD State Government" rsValid="contact_inputs" />
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <div class="label">Name</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="otherProperty.name" placeholder="John Smith" rsValid="contact_inputs" />
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <div class="label">Role / Position</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Role / Position</mat-label>
          <input matInput [(ngModel)]="otherProperty.role" placeholder="Role" rsValid="contact_inputs" />
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <div class="label">Address / Location</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Address / Location</mat-label>
          <input matInput [(ngModel)]="otherProperty.address" placeholder="PO Box 123, Somewhere, Out there" rsValid="contact_inputs" />
        </mat-form-field>
      </div>
    </div>
    <div class="field">
      <div class="label">Catchment</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Select Catchment</mat-label>

          <mat-select rsValid="required" [(ngModel)]="otherProperty.catchment">
            <mat-select-trigger>
              {{ otherProperty.catchment | titlecase }}
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search placeholderLabel="Search" noEntriesFoundLabel="Nothing found.."
                                     [ngModel]="searchText" (ngModelChange)="searchText = $event; filterItems()"
                                     ></ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="'None'">
              None
            </mat-option>
            <mat-option *ngFor="let catchment of filteredItems | async" [value]="catchment.name">
              {{ stateObjects[catchment.state]?.name }} - {{ catchment.groupname | titlecase }} - {{ catchment.name | titlecase }}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <div class="label">LGA</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>LGA</mat-label>

          <mat-select [(ngModel)]="otherProperty.lga" rsValid="required">
            <mat-select-trigger>
              {{ (otherProperty.lga | resolveLga).name }}
            </mat-select-trigger>
            <mat-option [value]="lga.id" *ngFor="let lga of (dataService$.localDefinitions | async)?.lga">
              {{lga.name}} ({{lga.type}})
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>
    </div>
  </div>
</rsValidForm>
<br/>
<ng-template #actionButtons>

  <button mat-button color="accent" (click)="close(false)" *ngIf="otherProperty.id">
    <mat-icon>preview</mat-icon> View History
  </button>

  <div class="flex-grow-1"></div>

  <button mat-button (click)="close()">
    Cancel
  </button>

  <button color="primary" mat-button (click)="saveOther()">
    <mat-icon>save</mat-icon> Save
  </button>

</ng-template>


